import React from "react";
import ResultOrShoqa from "./_ResultOrShoqa";

const SubjectResult = (props) => {
    return <ResultOrShoqa {...props} isShoqa={false} title={"شقه امتحان نهایی"}/>;
};

export default SubjectResult;
